export type Lang = 'es' | 'en';

const aboutBase = {
  actionChipsShared: ['Segway', 'Russian Arm', 'Ronin (Gimbal)'],
};

export const translations = {
  es: {
    nav: {
      about: 'Sobre mí',
      works: 'Trabajos',
      tools: 'Herramientas',
      contact: 'Contacto',
    },
    hero: {
      subtitle: 'Operador de cámara con 15 años de experiencia en cine y publicidad',
      cta: 'Ver Reel',
    },
    home: {
      title: 'Oriol Busquets',
    },
    about: {
      headline: 'Sobre mí',
      subtitle: '30 años detrás de la cámara.\nOperador de cámara especializado en cine y publicidad.',
      actionTitle: 'Especialidades',
      genresTitle: 'Experiencia',
      actionChips: ['Segway', 'Russian Arm', 'Ronin (Gimbal)', 'Esquí', 'Escalada', 'Manivelas'],
      genresChips: ['Moda y belleza', 'Narrativo', 'Acción'],
      location: 'Disponible en todo el mundo. Con base en España.',
      ctaWork: 'Ver trabajos',
      ctaContact: 'Contactar',
    },
    works: {
      title: 'Trabajos',
      reel: 'Reel',
      film: 'Cine',
      advertising: 'Publicidad',
      imdbText: 'Ver filmografía completa en IMDb',
      project: 'Proyecto',
      director: 'Director',
      dop: 'DOP',
      platform: 'Plataforma',
      brand: 'Marca',
      role: 'Rol',
      publishedAt: 'Fecha de publicación del vídeo',
      addWork: 'Añadir trabajo',
      editWork: 'Editar',
      deleteWork: 'Eliminar',
      videoUrl: 'URL del vídeo (YouTube o Vimeo)',
      projectName: 'Nombre del proyecto',
      save: 'Guardar',
      cancel: 'Cancelar',
      confirmDelete: '¿Eliminar este trabajo?',
      yes: 'Sí',
      no: 'No',
      viewAll: 'Ver todo',
    },
    tools: {
      title: 'Herramientas',
      subtitle: 'Equipamiento profesional',
      ronin: 'Ronin 2',
      segway: 'Segway i2 and X2 with handsfree',
      masterWheels: 'Master Wheels',
      easyrig: 'Easyrig Vario 5 + Stabil G3',
      cablecam: 'Cablecam Speed-Line',
      specialties: 'Especialidades',
      climbing: 'Escalada',
      skiing: 'Esquí',
      action: 'Secuencias de acción',
    },
    contact: {
      title: 'Contacto',
      phone: 'Teléfono',
      email: 'Email',
      sendEmail: 'Enviar email',
      name: 'Nombre',
      message: 'Mensaje',
      send: 'Enviar',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'Tu email',
      messagePlaceholder: 'Tu mensaje',
    },
    footer: {
      login: 'Iniciar sesión',
      logout: 'Cerrar sesión',
      rights: '© 2025 Oriol Busquets. Todos los derechos reservados.',
    },
    auth: {
      title: 'Acceso privado',
      email: 'Email',
      password: 'Contraseña',
      login: 'Entrar',
      back: 'Volver',
      error: 'Email o contraseña incorrectos',
    },
  },
  en: {
    nav: {
      about: 'About me',
      works: 'Works',
      tools: 'Equipment',
      contact: 'Contact',
    },
    hero: {
      subtitle: "Camera operator with 15 years' experience in film and commercials",
      cta: 'Watch Reel',
    },
    home: {
      title: 'Oriol Busquets',
    },
    about: {
      headline: 'About me',
      subtitle: '30 years behind the camera.\nSpecialist camera operator for film and commercials.',
      actionTitle: 'Skills',
      genresTitle: 'Experience',
      actionChips: ['Segway', 'Russian Arm', 'Ronin (Gimbal)', 'Ski', 'Climbing', 'Wheels'],
      genresChips: ['Fashion & Beauty', 'Narrative', 'Action'],
      location: 'Available worldwide. Based in Spain.',
      ctaWork: 'View Selected Work',
      ctaContact: 'Get in touch',
    },
    works: {
      title: 'Works',
      reel: 'Reel',
      film: 'Film',
      advertising: 'Commercials',
      imdbText: 'View full filmography on IMDb',
      project: 'Project',
      director: 'Director',
      dop: 'DOP',
      platform: 'Platform',
      brand: 'Brand',
      role: 'Role',
      publishedAt: 'Video publish date',
      addWork: 'Add work',
      editWork: 'Edit',
      deleteWork: 'Delete',
      videoUrl: 'Video URL (YouTube or Vimeo)',
      projectName: 'Project name',
      save: 'Save',
      cancel: 'Cancel',
      confirmDelete: 'Delete this work?',
      yes: 'Yes',
      no: 'No',
      viewAll: 'View all',
    },
    tools: {
      title: 'Equipment',
      subtitle: 'Professional equipment',
      ronin: 'Ronin 2',
      segway: 'Segway i2 and X2 with handsfree',
      masterWheels: 'Master Wheels',
      easyrig: 'Easyrig Vario 5 + Stabil G3',
      cablecam: 'Cablecam Speed-Line',
      specialties: 'Specialties',
      climbing: 'Climbing',
      skiing: 'Skiing',
      action: 'Action sequences',
    },
    contact: {
      title: 'Contact',
      phone: 'Phone',
      email: 'Email',
      sendEmail: 'Send email',
      name: 'Name',
      message: 'Message',
      send: 'Send',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'Your email',
      messagePlaceholder: 'Your message',
    },
    footer: {
      login: 'Log in',
      logout: 'Log out',
      rights: '© 2025 Oriol Busquets. All rights reserved.',
    },
    auth: {
      title: 'Private access',
      email: 'Email',
      password: 'Password',
      login: 'Sign in',
      back: 'Back',
      error: 'Invalid email or password',
    },
  },
};

export type Translations = typeof translations.es;
